import React from 'react';
import { ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { SectionReveal } from '../SectionReveal';
import { CTAButton } from '../CTAButton';
import { MERCADO_PAGO_LOGO } from '../../data/content';
const BADGES = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
export function FinalCta() {
  return <section className="w-full" style={{
    background: 'linear-gradient(180deg, #0A0A0A 0%, #7a3300 55%, #FF6B00 100%)'
  }} aria-labelledby="final-cta-heading" data-id="element-107">
      <SectionReveal className="mx-auto max-w-3xl px-5 py-20 text-center sm:py-24" data-id="element-108">
        <h2 id="final-cta-heading" className="font-display text-3xl text-white/70 line-through sm:text-4xl" data-id="element-109">
          $107.000 ARS
        </h2>
        <p className="mt-3 font-heading text-lg font-bold uppercase tracking-wide text-white" data-id="element-110">
          🔥 Hoy:
        </p>
        <p className="font-display text-6xl font-extrabold text-white sm:text-8xl" data-id="element-111">
          $19.900 ARS
        </p>

        <div className="mt-8 flex w-full justify-center" data-id="element-112">
          <CTAButton fullWidth pulse className="!bg-white !text-orange hover:!bg-white" data-id="element-113" />
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-114">
          {BADGES.map(({
          icon: Icon,
          label
        }) => <span key={label} className="flex items-center gap-2 text-sm text-white/90" data-id="element-115">
              <Icon className="h-4 w-4" data-id="element-116" />
              {label}
            </span>)}
        </div>

        <div className="mt-8 flex items-center justify-center gap-2 rounded-lg bg-white/95 px-4 py-3" data-id="element-117">
          <img src={MERCADO_PAGO_LOGO} alt="Mercado Pago" className="h-7 w-auto" data-id="element-118" />
          <span className="font-heading text-sm font-bold text-carbon" data-id="element-119">
            Pagás con Mercado Pago
          </span>
        </div>
      </SectionReveal>
    </section>;
}